import React, { useEffect, useState } from 'react';
import ProzoDataGrid, { lastPageRowCount, useFirstPageOnChange } from "../../../common/ProzoDataGrid";
import NetraScoreBadge from "../NetraScoreBadge";
import RtoRiskBadge from "../RtoRiskBadge";
import { Chip, Grid, Button, Typography, Box, Link as MuiLink, Stack, Tooltip, IconButton, Menu, MenuItem, ListItemIcon, ListItemText } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import SyncIcon from '@mui/icons-material/Sync';
import AssignmentTurnedInOutlinedIcon from '@mui/icons-material/AssignmentTurnedInOutlined';
import { LoadingButton } from '@mui/lab';
import { useDispatch, useSelector } from 'react-redux';
import { getOrderLists, syncOrder } from '../../../redux/actions/orderList/orderListAction';
import { resetOrderList } from '../../../redux/reducers/orderList/orderListSlice';
import Loader from '../../../common/Loader';
import { parseDateAndTime, getTotalUnitsOfOrder, maskAddress, shouldMaskData, formatDate, formatCurrency } from '../../../helpers/UtilityHelper';
import 'react-toastify/dist/ReactToastify.css';
import { exclude } from './index';
import { orderStatusClause } from './OrderStatusFilter';
import { Link } from 'react-router-dom'
import MUIModal from '../../../common/MUIModal';
import jwt_decode from "jwt-decode"
import { getToken, getRole } from '../../../helpers/ReduxHelpers';
import { apiConstants, postGeneric } from '../../../common/constants';
import { useSnackbar } from 'notistack';
import ConfirmDialog from '../../../common/ConfirmDialog';
import { primaryTextSx, secondaryTextSx, tertiaryTextSx, awbTextSx, cellStackSx, getStatusChipSx, getPaymentChipSx } from './cellStyles';
import ClientOrderIdText, { clientOrderIdClause } from './ClientOrderIdText';
import AwbLinkCell from '../../../common/AwbLinkCell';
import { abdFlagFilter } from '../../appointments/shared/constants';
import useCourierServiceType from '../../../hooks/useCourierServiceType';

const RTOOrders = (props) => {
  const dispatch = useDispatch();
  const { orderListInfo, loading } = useSelector((state) => state.orderListSlice);
  const { loading: orderSummaryLoading } = useSelector((state) => state.orderSummarySlice);
  const [page, setPage] = useState(0);
  const [sizePerPage, setSizePerPage] = useState(10);
  // New filters applied: start again from the first page.
  useFirstPageOnChange(props.filterChange, setPage);
  const [rowCountState, setRowCountState] = useState(props?.count || 0);
  const [itemModal, setItemModal] = useState(false);
  const [itemModalData, setItemModalData] = useState();
  const [actionMenu, setActionMenu] = useState(null);
  const closeActionMenu = () => setActionMenu(null);
  const runFromMenu = (fn) => () => { fn?.(); closeActionMenu(); };
  const { report } = useSelector(state => state);
  const { piiAccessAllow } = jwt_decode(getToken());
  const { enqueueSnackbar } = useSnackbar();
  // Backend gate is hasAnyRole(ROLE_ADMIN, ROLE_PROSHIPADMIN) — hide the
  // feature from ROLE_USER sub-users instead of letting them hit a 403.
  const userRoles = getRole() || [];
  const canMarkRtoReceived = userRoles.includes('ROLE_ADMIN') || userRoles.includes('ROLE_PROSHIPADMIN');
  const [rowSelectionModel, setRowSelectionModel] = useState([]);
  const [combinedData, setCombinedData] = useState([]);
  const [isMarkingReceived, setIsMarkingReceived] = useState(false);
  const [markReceivedConfirm, setMarkReceivedConfirm] = useState(false);
  const [menuReceivedRow, setMenuReceivedRow] = useState(null);
  const [menuReceivedConfirm, setMenuReceivedConfirm] = useState(false);
  const [reload, setReload] = useState(0);
  const { getServiceType } = useCourierServiceType();

  useEffect(() => {
    const andfilter = [];
    const orFilter = [];
    if (props.merchantId) {
      andfilter.push({
        field: "merchant.$id",
        operator: "eq",
        value: props.merchantId,
      });
    }
    // from date
    const statusClause = orderStatusClause(props.filters.status);
    if (statusClause) {
      andfilter.push(statusClause)
    } else {
      andfilter.push({ "field": "orderStatus", "operator": "in", "value": ['RTO_REQUESTED', 'RTO', 'RTO_INTRANSIT', 'RTO_CONTACT_CUSTOMER_CARE', 'RTO_SHIPMENT_DELAY', 'RTO_OUT_FOR_DELIVERY', 'RTO_FAILED', 'RTO_DELIVERED'] });
    }
    // status
    andfilter.push({ field: "shipmentType", operator: "eq", value: props.shipmentType });
    if (props.filters?.appointdeliveryRequired !== undefined && props.filters?.appointdeliveryRequired !== null && props.filters?.appointdeliveryRequired !== '') {
      andfilter.push(abdFlagFilter(props.filters.appointdeliveryRequired));
    }
    if (props.shipmentType === 'B2C') {
      andfilter.push({ field: "orderType", operator: "eq", value: 'FORWARD SHIPMENT' });
    }
    // if (!(props.filters.fromDate && props.filters.toDate)) {
    //   andfilter.push({ field: "awbRegisteredDate", operator: "gte", value: props.startDateForLastThirtyDays})
    // }


    if (props.filters) {
      // if (props.filters.reference) {
      //   andfilter.push({ "field": "reference", "operator": "eq", "value": props.filters.reference });
      // }
      const clientOrderFilter = clientOrderIdClause(props.filters);
      if (clientOrderFilter) {
        andfilter.push(clientOrderFilter);
      }
      if (props.filters.awb) {
        andfilter.push({ "field": "awbNumber", "operator": "eq", "value": props.filters.awb });
      }
      if (props.filters.rtoAwb) {
        andfilter.push({ "field": "rtoAwb", "operator": "eq", "value": props.filters.rtoAwb });
      }
      if (props.filters.city) {
        andfilter.push({ "field": "deliveryDetails.to_city", "operator": "eq", "value": props.filters.city });
      }
      if (props.filters.state) {
        andfilter.push({ "field": "deliveryDetails.to_state", "operator": "eq", "value": props.filters.state });
      }
      if (props.filters.fromDate) {
        andfilter.push({
          field: "awbRegisteredDate", operator: "gte",
          // value: formatDateForApi(props.filters.fromDate)
          value: `Date('${formatDate(props.filters.fromDate, 'yyyy-MM-dd')} 00:00:00')`
        })
      }
      if (props.filters.toDate) {
        andfilter.push({
          field: "awbRegisteredDate", operator: "lte",
          // value: formatDateForApi(props.filters.toDate) 
          value: `Date('${formatDate(props.filters.toDate, 'yyyy-MM-dd')} 23:59:59')`
        })
      }
      if (props.filters.payment_mode) {
        andfilter.push({
          field: "paymentMode",
          operator: "eq",
          value: props.filters.payment_mode,
        });
      }
      // "ne" also matches orders where the field is absent, which is every
      // shipment not yet marked — so NOT_MARKED works without an exists check.
      if (props.filters.rtoReceived === 'MARKED') {
        andfilter.push({ field: "orderSubStatus", operator: "eq", value: 'RTO_RECEIVED' });
      } else if (props.filters.rtoReceived === 'NOT_MARKED') {
        andfilter.push({ field: "orderSubStatus", operator: "ne", value: 'RTO_RECEIVED' });
      }
    }
    if (props.filters) {
      if (props.filters.reference) {
        orFilter.push({ "field": "reference", "operator": "eq", "value": props.filters.reference });
      }
      if (props.filters.reference) {
        orFilter.push({ "field": "shippingLabelId", "operator": "eq", "value": props.filters.reference });
      }

    }
    dispatch(resetOrderList());
    dispatch(getOrderLists({ "excludes": exclude, "andfilter": andfilter, "orfilter": orFilter, "offset": (page * sizePerPage), "limit": sizePerPage, "skipCount": true, "sort": { "field": "awbRegisteredDate", "direction": "DESC" } }));
    setRowCountState(props.count ? props.count : Number.MAX_VALUE);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, sizePerPage, props.filterChange, reload]);

  // Accumulate rows across pages so selected ids can be mapped back to AWBs
  // even after the user paginates away (keepNonExistentRowsSelected).
  useEffect(() => {
    if (orderListInfo?.data?.length > 0) {
      setCombinedData((prevData) => {
        const newData = orderListInfo.data.filter(newItem =>
          !prevData.some(prevItem => prevItem.id === newItem.id)
        );
        return [...prevData, ...newData];
      });
    }
  }, [orderListInfo?.data]);

  const handleSync = (awbNumber, reference) => {
    if (awbNumber) {
      dispatch(syncOrder({ waybill: awbNumber, reference: reference }));
      // console.log(orderListInfo);
    }
  }

  const isMarkableAsReceived = (row) =>
    row?.orderStatus === 'RTO_DELIVERED' && row?.orderSubStatus !== 'RTO_RECEIVED';

  const getSelectedEligibleAwbs = () =>
    combinedData
      .filter((row) => rowSelectionModel.includes(row.id) && isMarkableAsReceived(row))
      .map((row) => row.awb_number)
      .filter(Boolean);

  const openMarkReceivedConfirm = () => {
    if (getSelectedEligibleAwbs().length === 0) {
      enqueueSnackbar("Select at least one RTO Delivered shipment to proceed.", { variant: "warning" });
      return;
    }
    setMarkReceivedConfirm(true);
  };

  const markRtoReceivedFunc = () => {
    const awbNumbers = getSelectedEligibleAwbs();
    if (awbNumbers.length === 0) {
      enqueueSnackbar("Select at least one RTO Delivered shipment to proceed.", { variant: "warning" });
      return;
    }
    setIsMarkingReceived(true);
    postGeneric(apiConstants.MARK_RTO_RECEIVED, { awbNumbers })
      .then((res) => {
        if (res?.data?.status !== 'SUCCESS') {
          const msg = res?.data?.errorMsg || res?.data?.responseObj || 'Failed to mark RTO Received';
          enqueueSnackbar(typeof msg === 'string' ? msg : 'Failed to mark RTO Received', { variant: 'error' });
          return;
        }
        const result = res?.data?.responseObj || {};
        const failed = (result.results || []).filter((r) => r.status === 'FAILED');
        if (failed.length === 0) {
          enqueueSnackbar(`${result.successCount || awbNumbers.length} shipment(s) marked as RTO Received`, { variant: 'success' });
        } else {
          const firstError = failed[0]?.message || '';
          enqueueSnackbar(`${result.successCount || 0} marked, ${failed.length} failed. ${failed[0]?.awbNumber}: ${firstError}`,
            { variant: 'warning', autoHideDuration: 8000 });
        }
        setRowSelectionModel([]);
        setCombinedData([]);
        setReload((r) => r + 1);
      })
      .catch((err) => {
        console.log(err);
        const message = err?.response?.data?.errorMsg || err?.response?.data?.message || 'Something went wrong while marking RTO Received';
        enqueueSnackbar(message, { variant: 'error' });
      })
      .finally(() => setIsMarkingReceived(false));
  }

  // Single-row variant fired from the per-row ⋮ menu.
  const markSingleRtoReceived = (row) => {
    if (!row?.awb_number) return;
    postGeneric(apiConstants.MARK_RTO_RECEIVED, { awbNumbers: [row.awb_number] })
      .then((res) => {
        if (res?.data?.status !== 'SUCCESS') {
          const msg = res?.data?.errorMsg || 'Failed to mark RTO Received';
          enqueueSnackbar(typeof msg === 'string' ? msg : 'Failed to mark RTO Received', { variant: 'error' });
          return;
        }
        const result = res?.data?.responseObj || {};
        const failed = (result.results || []).find((r) => r.status === 'FAILED');
        if (failed) {
          enqueueSnackbar(failed.message || 'Failed to mark RTO Received', { variant: 'error' });
        } else {
          enqueueSnackbar('Shipment marked as RTO Received', { variant: 'success' });
          setCombinedData([]);
          setReload((r) => r + 1);
        }
      })
      .catch((err) => {
        console.log(err);
        const message = err?.response?.data?.errorMsg || err?.response?.data?.message || 'Something went wrong while marking RTO Received';
        enqueueSnackbar(message, { variant: 'error' });
      });
  }

  const columns = [
    {
      field: 'actions', headerAlign: "center", hideSortIcons: true, headerName: 'Order Details', flex: 1.3, minWidth: 160, renderCell: (params) => {
        const { row } = params;
        return (
          <Box sx={cellStackSx}>
            <Typography sx={primaryTextSx}>{row.reference}</Typography>
            {row.shippingLabelId && row.reference !== row.shippingLabelId && (
              <Typography sx={secondaryTextSx}>{row.shippingLabelId}</Typography>
            )}
            <ClientOrderIdText row={row} />
            <Typography sx={secondaryTextSx}>
              {row.createdDate ? parseDateAndTime(row.createdDate) : ""}
            </Typography>
            {row.channel_name && row.channel_name !== 'Unicom' && row.channel_name !== 'WMS' && (
              <Typography sx={tertiaryTextSx}>{row.channel_name}</Typography>
            )}
          </Box>
        )
      },
    },
    {
      field: "courier", headerAlign: "center", hideSortIcons: true, headerName: "Courier Partner", flex: 1, minWidth: 140,
      renderCell: (params) => {
        const { row } = params;
        let courierParent = row.courierDetail?.parent?.includes('Blended') ? row.actualCourierProviderName : row.courierDetail?.parent;
        const serviceType = getServiceType(row.courierDetail?.prozoId);
        return (
          <Box sx={cellStackSx}>
            <AwbLinkCell awb={row.awb_number} sx={awbTextSx} />
            <Typography sx={secondaryTextSx}>{courierParent}</Typography>
            {serviceType && <Typography sx={tertiaryTextSx}>{serviceType}</Typography>}
          </Box>
        );
      },
    },
    {
      field: 'delivery', headerAlign: "center", hideSortIcons: true, headerName: 'Delivery Details', flex: 1.5, minWidth: 180, renderCell: (params) => {
        const { row } = params;
        const pickupName = row.pickup_details?.from_name || "-NA-";
        const pickupPin = row.pickup_details?.from_pincode || "-NA-";
        const deliveryName = row.delivery_details?.to_name || "";
        const deliveryPin = (row.delivery_details?.to_pincode)
          ? (shouldMaskData(report, row, piiAccessAllow) ? maskAddress(row.delivery_details.to_pincode) : row.delivery_details.to_pincode)
          : "-NA-";
        return (
          <Box sx={cellStackSx}>
            <Typography sx={secondaryTextSx}>
              <Typography component="span" sx={{ ...primaryTextSx, fontSize: 'inherit' }}>Pickup: </Typography>
              {pickupName}, {pickupPin}
            </Typography>
            <Typography sx={secondaryTextSx}>
              <Typography component="span" sx={{ ...primaryTextSx, fontSize: 'inherit' }}>Delivery: </Typography>
              {deliveryName}, {deliveryPin}
            </Typography>
            {row.netra_address && (
              <Box sx={{ mt: 0.3 }}><NetraScoreBadge netra={row.netra_address} orderId={row.id} /></Box>
            )}
            {row.netra_rto && (
              <Box sx={{ mt: 0.3 }}><RtoRiskBadge netra={row.netra_rto} orderId={row.id} /></Box>
            )}
          </Box>
        )
      },
    },
    {
      field: 'shipment', headerAlign: "center", hideSortIcons: true, headerName: 'Package Details', flex: 1, minWidth: 120, renderCell: (params) => {
        const { row } = params;
        const sd = row.shipment_detail?.[0];
        return (
          <Box sx={cellStackSx}>
            <Typography sx={secondaryTextSx}>DW: {sd ? `${(sd.item_weight / 1000).toFixed(2)} kg` : ""}</Typography>
            <Typography sx={secondaryTextSx}>VW: {sd ? `${((sd.item_length * sd.item_breadth * sd.item_height) / 5000).toFixed(2)} kg` : ""}</Typography>
            {sd && <Typography sx={tertiaryTextSx}>{sd.item_length} x {sd.item_breadth} x {sd.item_height} cm</Typography>}
          </Box>
        )
      },
    },
    {
      field: 'itemDetails', headerAlign: "center", hideSortIcons: true, headerName: 'Item Details', flex: 0.7, minWidth: 90, renderCell: (params) => {
        const { row } = params;
        return (
          <Box sx={cellStackSx}>
            <Typography sx={primaryTextSx}>{getTotalUnitsOfOrder(row.item_list)} units</Typography>
            <MuiLink
              component="button"
              variant="body2"
              sx={{ fontSize: 11, textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}
              onClick={() => { setItemModalData(row.item_list); setItemModal(true); }}
            >
              View Items
            </MuiLink>
          </Box>
        )
      },
    },
    {
      field: 'paymentDetails', headerAlign: "center", hideSortIcons: true, headerName: 'Payment Details', flex: 0.7, minWidth: 100, renderCell: (params) => {
        const { row } = params;
        const paymentMode = row.payment_mode || '';
        return (
          <Box sx={cellStackSx}>
            <Typography sx={primaryTextSx}>{row.invoice_value ? formatCurrency(row.invoice_value) : ""}</Typography>
            {paymentMode && <Chip size="small" label={paymentMode} sx={getPaymentChipSx(paymentMode)} />}
          </Box>
        )
      },
    },
    {
      field: 'statusDetails', headerAlign: "center", hideSortIcons: true, headerName: 'Status', flex: 1, minWidth: 120, renderCell: (params) => {
        const { row } = params;
        return (
          <Stack spacing={1} alignItems="center">
            <Chip size="small" label={row.orderStatus} sx={getStatusChipSx(row.orderStatus)} />
            {row.orderSubStatus === 'RTO_RECEIVED' && (
              <Chip variant="outlined" size="small" color="success" label="RTO Received" />
            )}
          </Stack>
        )
      },
    },
    {
      field: 'action', headerAlign: "center", hideSortIcons: true, headerName: 'Action', flex: 1.1, minWidth: 160, renderCell: (params) => {
        const { row } = params;
        return (
          <Stack direction="row" spacing={0.5} alignItems="center" justifyContent="center" sx={{ width: '100%' }}>
            <Button variant="contained" size="small" component={Link} to={`/order-detail?waybill=${row.awb_number}`}
              target="_blank" rel="noopener noreferrer"
              sx={{ whiteSpace: 'nowrap', textTransform: 'none', fontWeight: 600, px: 2, fontSize: 12 }}
            >Details</Button>
            <Tooltip title="More actions">
              <IconButton size="small" onClick={(e) => setActionMenu({ anchorEl: e.currentTarget, row })}
                sx={{ bgcolor: 'background.paper', border: '1px solid', borderColor: 'divider', borderRadius: 1, width: 32, height: 32, '&:hover': { bgcolor: 'grey.100' } }}>
                <MoreVertIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          </Stack>
        )
      },
    },
  ];

  const columnsItemModal = [
    { field: 'sku_id', headerAlign: "center", hideSortIcons: true, headerName: 'SKU', width: 130 },
    { field: 'item_name', headerAlign: "center", hideSortIcons: true, headerName: 'SKU Name', width: 200 },
    { field: 'units', headerAlign: "center", hideSortIcons: true, headerName: 'Units', width: 100 }
  ]
  useEffect(() => {
    setRowCountState((prevRowCountState) =>
      props?.count !== undefined ? props?.count : prevRowCountState,
    );
  }, [props?.count, setRowCountState]);


  return (
    <>
      <Grid item container spacing={2}>
        {(loading || orderSummaryLoading) && <Loader />}
        {canMarkRtoReceived && rowSelectionModel.length > 0 && (
          <Grid item xs={12}>
            <Stack direction="row" spacing={2} alignItems="center">
              <LoadingButton
                variant="contained"
                size="small"
                color="success"
                loading={isMarkingReceived}
                onClick={openMarkReceivedConfirm}
              >
                Mark RTO Received ({rowSelectionModel.length})
              </LoadingButton>
              <Typography variant="subtitle2" color="text.secondary">
                Only RTO Delivered shipments can be marked as received.
              </Typography>
            </Stack>
          </Grid>
        )}
        <Grid item xs={12}>
          <ProzoDataGrid columns={columns}
            // disableColumnFilter={true}rowsPerPageOptions
            autoHeight={true}
            rows={(orderListInfo.data && orderListInfo.data.length > 0) ? orderListInfo.data : []}
            checkboxSelection={canMarkRtoReceived}
            keepNonExistentRowsSelected={true}
            rowSelectionModel={rowSelectionModel}
            setRowSelectionModel={setRowSelectionModel}
            isRowSelectable={(params) => isMarkableAsReceived(params.row)}
            sizePerPage={sizePerPage}
            setSizePerPage={setSizePerPage}
            setPage={setPage}
            page={page}
            pagination={true}
            hideFooterPagination={false}
            filterMode={"server"}
            rowCount={lastPageRowCount({ page, pageSize: sizePerPage, rowsOnPage: orderListInfo?.data?.length, loading })}
            getRowId={(row) => row.id} />
        </Grid>
      </Grid>

      <ConfirmDialog
        title='Mark RTO Received'
        open={markReceivedConfirm}
        setOpen={setMarkReceivedConfirm}
        onConfirm={() => markRtoReceivedFunc()}
      >
        Mark {getSelectedEligibleAwbs().length} shipment(s) as physically received back?
        This confirms the RTO shipment(s) have reached you and cannot be undone from the panel.
      </ConfirmDialog>

      <Menu anchorEl={actionMenu?.anchorEl} open={Boolean(actionMenu)} onClose={closeActionMenu}
        PaperProps={{ sx: { minWidth: 200, '& .MuiMenuItem-root': { fontSize: 12, py: 0.75 }, '& .MuiListItemText-primary': { fontSize: 12 }, '& .MuiListItemIcon-root': { minWidth: 28 } } }}>
        <MenuItem onClick={runFromMenu(() => handleSync(actionMenu?.row?.awb_number, actionMenu?.row?.reference))}>
          <ListItemIcon><SyncIcon fontSize="small" /></ListItemIcon>
          <ListItemText>Resync</ListItemText>
        </MenuItem>
        {canMarkRtoReceived && isMarkableAsReceived(actionMenu?.row) && (
          <MenuItem onClick={runFromMenu(() => { setMenuReceivedRow(actionMenu.row); setMenuReceivedConfirm(true); })}>
            <ListItemIcon><AssignmentTurnedInOutlinedIcon fontSize="small" sx={{ color: 'success.main' }} /></ListItemIcon>
            <ListItemText>Mark RTO Received</ListItemText>
          </MenuItem>
        )}
      </Menu>

      <ConfirmDialog
        title='Mark RTO Received'
        open={menuReceivedConfirm}
        setOpen={setMenuReceivedConfirm}
        onConfirm={() => markSingleRtoReceived(menuReceivedRow)}
      >
        Mark shipment <strong>{menuReceivedRow?.awb_number}</strong> as physically received back?
        This confirms the RTO shipment has reached you and cannot be undone from the panel.
      </ConfirmDialog>
      <MUIModal
        open={itemModal}
        title="Item Details"
        handleClose={() => setItemModal(false)}
        maxWidth="sm"
      >
        <ProzoDataGrid
          autoHeight={false}
          columns={columnsItemModal}
          rows={itemModalData}
          // pagination={false}
          paginationMode="client"
          rowCount={itemModalData?.length}
          getRowId={(row) => row.sku_id} />
      </MUIModal>
    </>
  );
};

export default RTOOrders
